module.exports = __webpack_public_path__ + "img/drive.bf6460cb.jpg";